const default_data = {
    billing: {
        address_1: '',
        address_2: '',
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
    },
    location: {
        coordinates: []
    },
    dismiss: false
}

function reducer( state = default_data, { type, payload } ){
    switch( type ){
        case 'refrescarUser': {
            return payload
        }
        default:
            return state
    }
}

export default reducer